export default "__VITE_ASSET__v88cb4j4__"